/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { FileSummaryModel } from './file-summary-model';

/**
 * 新着通知
 * @export
 * @interface NewArrivalNotificationModel
 */
export interface NewArrivalNotificationModel {
    /**
     * 新着通知ID
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'new_arrival_notification_id'?: string;
    /**
     * 内容タグID
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'content_tag_id'?: string;
    /**
     * 内容タグ名
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'content_tag_name'?: string;
    /**
     * データラックID
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'data_rack_id'?: string;
    /**
     * データラック名
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'data_rack_name'?: string;
    /**
     * データボックスID
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'data_box_id'?: string;
    /**
     * 通知内容区分
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'notification_content_type'?: string;
    /**
     * 通知内容
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'notification_content'?: string;
    /**
     * 既未読区分 - 既読:READ - 未読:UNREAD 
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'read_content_type'?: NewArrivalNotificationModelReadContentTypeEnum;
    /**
     * 更新日時 <br> 画面表示用にオフセット計算した値 
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'updated_at'?: string | null;
    /**
     * 発信元名 <br> 画面表示用にロケールに対応する形式に以下を変換した値 <br> 発信元姓、発信元名 
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'source_user_name_without_middle_name'?: string;
    /**
     * 発信元X-grabユーザ企業名
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'source_xgrab_user_company_name'?: string;
    /**
     * ファイル拡張子情報
     * @type {string}
     * @memberof NewArrivalNotificationModel
     */
    'file_extension'?: string;
    /**
     * ダウンロード可能フラグ
     * @type {boolean}
     * @memberof NewArrivalNotificationModel
     */
    'downloadable_flag'?: boolean;
    /**
     * 強調表示フラグ
     * @type {boolean}
     * @memberof NewArrivalNotificationModel
     */
    'highlight_flag'?: boolean;
    /**
     * ファイル情報リスト
     * @type {Array<FileSummaryModel>}
     * @memberof NewArrivalNotificationModel
     */
    'files'?: Array<FileSummaryModel>;
}

export const NewArrivalNotificationModelReadContentTypeEnum = {
    Unread: 'UNREAD',
    Read: 'READ'
} as const;

export type NewArrivalNotificationModelReadContentTypeEnum = typeof NewArrivalNotificationModelReadContentTypeEnum[keyof typeof NewArrivalNotificationModelReadContentTypeEnum];


